/**
 * Pre-compiled pt-BR messages for Pagination
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  currentPage: `Página atual`,
  goToNextPage: `Ir para a próxima página`,
  goToPreviousPage: `Ir para a página anterior`,
  itemsPerPage: `Itens por página`,
  itemsPerPageText: `Itens por página`,
  ofTotalPages: (args: Record<string, string | number>) =>
    `de ${args.totalPages}`,
  page: `Página`,
  pagination: `Paginação`,
};
